import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconTheatre: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16 8h5c.6 0 1 .4 1 1v5.4c0 4.3-3.1 7.6-7 7.6-3.4 0-6.2-2.5-6.9-6.1C4.6 15.5 2 12.3 2 8.4V3c0-.6.4-1 1-1h12c.6 0 1 .4 1 1v5zM4 4v4.4C4 11.5 6.2 14 9 14s5-2.5 5-5.6V4H4zm11 16c2.8 0 5-2.5 5-5.6V10h-4.1c-.6 3.1-2.8 5.4-5.7 5.9.5 2.4 2.5 4.1 4.8 4.1zM11.7 9.3c.4.4.4 1 0 1.4-.1.1-1.3 1.3-2.7 1.3-1.4 0-2.6-1.2-2.7-1.3-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0 .3.3.9.7 1.3.7s1-.4 1.3-.7c.4-.4 1-.4 1.4 0zM7 7a1 1 0 100-2 1 1 0 000 2zm5-1a1 1 0 11-2 0 1 1 0 012 0zm5 7a1 1 0 100-2 1 1 0 000 2zm-4.7 3.3c.1-.1 1.3-1.3 2.7-1.3 1.4 0 2.6 1.2 2.7 1.3.4.4.4 1 0 1.4-.2.2-.5.3-.7.3-.2 0-.5-.1-.7-.3-.3-.3-.9-.7-1.3-.7s-1 .4-1.3.7c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    })
  )
}
